import { ArrowRight } from "lucide-react";

export const ResumeReviewCard = ({ onAction, ctaLabel = "Get my CV reviewed", testId = "resume-review-card" }) => (
  <div className="bg-[#f5f3ee] border border-[#e3e0d3] rounded-xl p-8 sm:p-10" data-testid={testId}>
    <div className="flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
      <div>
        <p className="font-accent text-lg text-[#7C8514]">Add-on · CV ready in 48h</p>
        <h3 className="font-heading text-2xl sm:text-3xl font-extrabold text-[#0d2f4d] tracking-tight mt-2">
          Resume Review <span className="font-accent font-medium">& Builder</span>
        </h3>
        <p className="text-[#51637a] mt-3 max-w-xl leading-relaxed">
          Get your CV market-ready for Australian recruiters — written feedback,
          one revised version with track-changes, 48-hour turnaround.
        </p>
        <p className="text-sm text-[#51637a] mt-4">
          · AU hiring &amp; ATS audit&nbsp;&nbsp;&nbsp;· Written feedback report&nbsp;&nbsp;&nbsp;· Revised version (track-changes)&nbsp;&nbsp;&nbsp;· 48-hour turnaround
        </p>
      </div>
      <div className="shrink-0 flex flex-col items-start lg:items-end gap-4">
        <p className="font-heading text-3xl sm:text-4xl font-extrabold text-[#0d2f4d]">A$207</p>
        <button onClick={onAction} data-testid={`${testId}-cta`}
          className="inline-flex items-center gap-2 rounded-full bg-[#C1CC24] text-[#0d2f4d] font-semibold px-7 py-3.5 hover:bg-[#aeb81f] transition-colors">
          {ctaLabel} <ArrowRight size={17} />
        </button>
      </div>
    </div>
  </div>
);
